// Helper to build WhatsApp deep links with optional pre-filled message templates.
// Templates support placeholders: {car_name}, {pickup}, {return}, {days}, {total}, {site}
export const sanitizePhone = (p) => (p || "").replace(/[^\d+]/g, "");

const DEFAULT_TEMPLATES = {
  ro: "Buna! Sunt interesat de inchirierea masinii {car_name}. Perioada: {pickup} - {return} ({days} zile). Pretul estimat: {total}. Va rog sa-mi confirmati disponibilitatea. Multumesc!",
  en: "Hi! I'm interested in renting {car_name}. Period: {pickup} - {return} ({days} days). Estimated price: {total}. Please confirm availability. Thank you!",
  ro_short: "Buna! Sunt interesat de masina {car_name}. Mai sunt disponibile detalii?",
  en_short: "Hi! I'm interested in {car_name}. Are more details available?",
  ro_generic: "Buna! As vrea sa primesc mai multe detalii despre serviciile voastre de inchirieri auto.",
  en_generic: "Hi! I'd like to get more details about your car rental services.",
};

const fill = (template, vars) => {
  let out = template || "";
  Object.entries(vars || {}).forEach(([k, v]) => {
    out = out.split(`{${k}}`).join(v == null ? "" : String(v));
  });
  // Clean up any remaining placeholders
  return out.replace(/\s+\([^)]*\{[^}]+\}[^)]*\)/g, "").replace(/\{[^}]+\}/g, "").replace(/\s{2,}/g, " ").trim();
};

export function buildWhatsappUrl({ phone, message }) {
  const p = sanitizePhone(phone || "").replace(/^\+/, "");
  if (!p) return "#";
  const txt = encodeURIComponent(message || "");
  return `https://wa.me/${p}${txt ? `?text=${txt}` : ""}`;
}

export function getWhatsappMessage({ settings, lang, kind, vars }) {
  // kind: 'detailed' | 'short' | 'generic'
  const fc = settings?.floating_contact || {};
  let template;
  if (kind === "detailed") {
    template = lang === "en"
      ? fc.whatsapp_template_en || DEFAULT_TEMPLATES.en
      : fc.whatsapp_template_ro || DEFAULT_TEMPLATES.ro;
  } else if (kind === "short") {
    template = lang === "en" ? DEFAULT_TEMPLATES.en_short : DEFAULT_TEMPLATES.ro_short;
  } else {
    template = lang === "en" ? DEFAULT_TEMPLATES.en_generic : DEFAULT_TEMPLATES.ro_generic;
  }
  return fill(template, vars || {});
}

export { DEFAULT_TEMPLATES as WA_DEFAULT_TEMPLATES };
